<template>
  <!-- modal cadastro -->
  <b-modal id="modal-cadastrar" dialog-class="modal-questao" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title" v-if="!isVisualizacao && questaoEdicao">Editar questão</h5>
      <h5 class="modal-title" v-if="!isVisualizacao && !questaoEdicao">Cadastrar questão</h5>
      <h5 class="modal-title" v-if="isVisualizacao">Visualizar questão</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form enctype="multipart/form-data">
    <fieldset :disabled="isVisualizacao">
      <h6><i class="fas fa-user-tag"></i> Tipo de questão</h6>
      <div class="row">
        <div class="col-12 col-md-6">
          <form-group id="tipoQuestao" label="Tipo" label-class="sr-only" :text="{ required: 'Obrigatório informar o tipo de questão' }" :field="$v.questao.tipo_questao_id">
            <select class="form-control" v-model="questao.tipo_questao_id">
              <option value="1">Múltipla escolha</option>
            </select>
          </form-group>
        </div>
      </div>
      <h6><i class="fas fa-key"></i> Dados da questão</h6>
      <div class="row">
        <div class="col-12 col-md-12">
          <form-group id="nomeQuestao"  label="Nome *" :text="{ required: 'Obrigatório informar o nome da questão' }" :field="$v.questao.questao">
            <input type="text" class="form-control" id="nome" placeholder="" v-model="questao.questao" />
          </form-group>
        </div>

        <div class="col-12 col-md-2">
          <form-group id="anoQuestao"  label="Ano *" :text="{ required: 'Obrigatório informar o ano da questão' }" :field="$v.questao.ano">
            <input type="text" class="form-control" id="ano" placeholder="" v-model="questao.ano" />
          </form-group>
        </div>

        <div class="col-12 col-md-10">
          <div class="form-group">
            <label for="professor">Professor</label>
            <select class="form-control" id="professor" v-model="questao.professor_id">
              <option v-if="professores.length == 0" value="">Carregando...</option>
              <option v-if="professores.length > 0" value="">Selecione</option>
              <option v-for="professor in professores" :value="professor.id">{{ professor.professor }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-10">
          <div class="form-group">
            <label for="publico">Público Alvo</label>
            <select class="form-control" id="publico" v-model="questao.publico_id">
              <option v-if="publicoAlvo.length == 0" value="">Carregando...</option>
              <option v-if="publicoAlvo.length > 0" value="">Selecione</option>
              <option v-for="publico in publicoAlvo" :value="publico.id">{{ publico.publico }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-10" v-if="fontesFiltradas && fontesFiltradas.length > 0">
          <div class="form-group">
            <label for="fonte">Fonte</label>
            <select class="form-control" id="fonte" v-model="questao.fonte_id">
              <option value="">Selecione</option>
              <option v-for="fonte in fontesFiltradas" :value="fonte.id">{{ fonte.descricao }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-10" v-if="modalidadesDisponiveis && modalidadesDisponiveis.length > 0">
          <div class="form-group">
            <label for="modalidade">Modalidade</label>
            <select class="form-control" id="modalidade" v-model="questao.modalidade_id">
              <option value="">Selecione</option>
              <option v-for="modalidade in modalidadesDisponiveis" :value="modalidade.id">{{ modalidade.descricao }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-10">
          <div class="form-group">
            <label for="curso">Curso</label>
            <select class="form-control" id="curso" v-model="questao.curso_original_id">
              <option v-if="cursos.length == 0" value="undefined">Carregando...</option>
              <option v-if="cursos.length > 0" value="undefined">Selecione</option>
              <option v-for="curso in cursos" :value="curso.id">{{ curso.curso }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-10" v-if="modulosFiltrados && modulosFiltrados.length > 0">
          <div class="form-group">
            <label for="modulo">Módulo</label>
            <select class="form-control" id="modulo" v-model="questao.modulo_original_id">
              <option value="">Selecione</option>
              <option v-for="modulo in modulosFiltrados" :value="modulo.id">{{ modulo.modulo }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-10" v-if="licoesDisponiveis && licoesDisponiveis.length > 0">
          <div class="form-group">
            <label for="licao">Lição</label>
            <select class="form-control" id="licao" v-model="questao.licao_original_id">
              <option value="">Selecione</option>
              <option v-for="licao in licoesDisponiveis" :value="licao.id">{{ licao.licao }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-12">
          <form-group id="enunciadoQuestao"  label="Enunciado *" :text="{ required: 'Obrigatório informar o enunciado da questão' }" :field="$v.questao.enunciado">
            <textarea class="form-control" id="enunciado" rows="3" v-model="questao.enunciado"></textarea>
          </form-group>
        </div>

        <div class="col-12 col-md-12">
          <div class="form-group">
            <label for="imagensEnunciado">Adicionar imagem ao enunciado</label>
            <div class="input-group mb-3">
              <b-form-file
                v-model="imagem_selecionada_enunciado"
                placeholder="Escolha uma imagem"
                drop-placeholder="Solte um arquivo aqui..."
                browse-text="Selecionar"
                accept="image/jpeg, image/png"
              ></b-form-file>
            </div>
          </div>
          <div class="form-group" v-if="(questao.imagensEnunciado && questao.imagensEnunciado.length > 0) || (questao.imagens_enunciado && questao.imagens_enunciado.length > 0)">
            <label  class="mt-3" for="lsita">Imagens selecionadas:</label>
            <div class="mt-2" v-for="imagem in questao.imagensEnunciado" :key="imagem.name">
              {{ imagem && imagem.name }} <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="excluirImagemEnunciado(imagem)"><i class="fas fa-trash-alt"></i></a>
            </div>
            <div class="mt-2" v-for="imagem in questao.imagens_enunciado" :key="imagem.name">
              <a target="_blank" :href="obterUrlS3(imagem.arquivo)">{{imagem.arquivo}}</a> <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="excluirImagemEnunciadoGravadas(imagem)"><i class="fas fa-trash-alt"></i></a>
            </div>
          </div>
        </div>
      </div>
      <h6 v-if="isMultiplaEscolha"><i class="fas fa-user"></i> Opções</h6>
      <h6 v-if="isDiscursiva"><i class="fas fa-user"></i> Gabarito</h6>
      <div class="row" v-if="isMultiplaEscolha">
        <div class="col-12 col-md-12">
          <form-group id="resposta1" label="Opção 1 *" label-class="sr-only" :text="{ required: 'Obrigatório informar a opção 1 de resposta' }" :field="$v.questao.resposta1">
            <input type="text" class="form-control" placeholder="Opção de resposta 1" v-model="questao.resposta1" />
          </form-group>
        </div>
        <div class="col-12 col-md-12">
          <form-group id="resposta2" label="Opção 2 *" label-class="sr-only" :text="{ required: 'Obrigatório informar a opção 2 de resposta' }" :field="$v.questao.resposta2">
            <input type="text" class="form-control" placeholder="Opção de resposta 2" v-model="questao.resposta2" />
          </form-group>
        </div>
        <div class="col-12 col-md-12">
          <form-group id="resposta3" label="Opção 3 *" label-class="sr-only" :text="{ required: 'Obrigatório informar a opção 3 de resposta' }" :field="$v.questao.resposta3">
            <input type="text" class="form-control" placeholder="Opção de resposta 3" v-model="questao.resposta3" />
          </form-group>
        </div>
        <div class="col-12 col-md-12">
          <form-group id="resposta4" label="Opção 4 *" label-class="sr-only" :text="{ required: 'Obrigatório informar a opção 4 de resposta' }" :field="$v.questao.resposta4">
            <input type="text" class="form-control" placeholder="Opção de resposta 4" v-model="questao.resposta4" />
          </form-group>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label class="sr-only">Opção 5</label>
            <input type="text" class="form-control" placeholder="Opção de resposta 5" v-model="questao.resposta5" />
          </div>
        </div>
        <div class="col-12 col-md-6">
          <form-group id="opcaoCorreta" label="Opção correta *" :text="{ required: 'Obrigatório informar a opção correta' }" :field="$v.questao.opcao_correta">
            <select class="form-control"  v-model="questao.opcao_correta">
              <option v-for="opcao in opcoesCorretas" :value="opcao.id">{{ opcao.texto }}</option>
            </select>
          </form-group>
        </div>
      </div>
      <div class="row" v-if="isDiscursiva">
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label class="sr-only">Gabarito</label>
            <textarea class="form-control" rows="3" v-model="questao.gabarito_discursiva"></textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label>Comentário</label>
            <textarea class="form-control" rows="3" v-model="questao.comentario_feedback"></textarea>
          </div>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label for="imagensComentario">Adicionar imagem ao comentário</label>
            <div class="input-group mb-3">
              <b-form-file
                v-model="imagem_selecionada_comentario"
                placeholder="Escolha uma imagem"
                drop-placeholder="Solte um arquivo aqui..."
                browse-text="Selecionar"
                accept="image/jpeg, image/png"
              ></b-form-file>
            </div>
          </div>
          <div class="form-group" v-if="(questao.imagensComentario && questao.imagensComentario.length > 0) || (questao.imagens_comentario && questao.imagens_comentario.length > 0)">
            <label  class="mt-3" for="lsita">Imagens selecionadas:</label>
            <div class="mt-2" v-for="imagem in questao.imagensComentario" :key="imagem.name">
              {{ imagem && imagem.name }} <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="excluirImagemComentario(imagem)"><i class="fas fa-trash-alt"></i></a>
            </div>
            <div class="mt-2" v-for="imagem in questao.imagens_comentario" :key="imagem.name">
              <a target="_blank" :href="obterUrlS3(imagem.arquivo)">{{imagem.arquivo}}</a> <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="excluirImagemComentarioGravadas(imagem)"><i class="fas fa-trash-alt"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="editarQuestao" v-if="isEdicao">Salvar</button>
          <button class="btn btn-primary mr-3" type="button" @click="cadastrarQuestao" v-else>Cadastrar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar')">Cancelar</a>
        </div>
      </div>
    </fieldset>
    </form>
  </b-modal>
</template>

<script>
import QuestaoAPI from '@/api/questao-api'
import Swal from 'sweetalert2'
import UrlUtils from '@/core/util/url-utils'
import ResponseUtils from '@/core/util/response-utils'
import { required, requiredIf } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'

export default {
  name: 'ModalCadastroQuestao',
  components: { FormGroup },
  props: {
    questaoEdicao: Object,
    professores: Array,
    modalidades: Array,
    publicoAlvo: Array,
    fontes: Array,
    cursos: Array,
    modulos: Array,
    licoes: Array,
    visualizar: Boolean
  },
  data () {
    return {
      opcoesCorretas: [
        { id: 1, texto: 'Opção 1' },
        { id: 2, texto: 'Opção 2' },
        { id: 3, texto: 'Opção 3' },
        { id: 4, texto: 'Opção 4' },
        { id: 5, texto: 'Opção 5' }
      ],
      questao: {
        tipo_questao_id: 1,
        questao: '',
        enunciado: '',
        resposta1: '',
        resposta2: '',
        resposta3: '',
        resposta4: '',
        resposta5: '',
        opcao_correta: '',
        gabarito_discursiva: '',
        comentario_feedback: '',
        ano: '',
        professor_id: '',
        modalidade_id: '',
        publico_id: '',
        fonte_id: '',
        curso_original_id: '',
        modulo_original_id: '',
        licao_original_id: '',
        imagensEnunciado: [],
        imagensComentario: []
      },
      imagem_selecionada_enunciado: [],
      imagem_selecionada_comentario: []
    }
  },

  computed: {
    isEdicao: function () {
      return this.questaoEdicao && this.questaoEdicao.id > 0
    },

    isVisualizacao: function () {
      return this.visualizar
    },

    isMultiplaEscolha: function () {
      return this.questao.tipo_questao_id === 1 || this.questao.tipo_questao_id === '1'
    },

    isDiscursiva: function () {
      return this.questao.tipo_questao_id === 2 || this.questao.tipo_questao_id === '2'
    },

    modalidadesDisponiveis: function () {
      return this.modalidades.filter(modalidade => (
        modalidade.publico.id === this.questao.publico_id &&
        modalidade.fonte.id === this.questao.fonte_id
      ))
    },

    fontesFiltradas: function () {
      let modalidadesIds = []
      this.modalidades.map(modalidade => {
        modalidade.publico.id === this.questao.publico_id &&
        modalidadesIds.push(modalidade.fonte.id)
      })
      return this.fontes.filter(fonte => {
        return modalidadesIds.includes(fonte.id)
      })
    },

    modulosFiltrados: function () {
      let licoesIds = []
      this.licoes.map(licao => {
        licao.ementa && licao.ementa.curso_id === this.questao.curso_original_id &&
        licoesIds.push(licao.ementa.modulo_id)
      })
      return this.modulos.filter(modulo => {
        return licoesIds.includes(modulo.id)
      })
    },

    licoesDisponiveis: function () {
      return this.licoes.filter(licao => (
        licao.ementa && licao.ementa.modulo_id === this.questao.modulo_original_id
      ))
    }
  },

  watch: {
    imagem_selecionada_enunciado: function () {
      if (this.imagem_selecionada_enunciado) {
        this.excluirImagemEnunciado(this.imagem_selecionada_enunciado)
        this.questao.imagensEnunciado.push(this.imagem_selecionada_enunciado)
      }
    },

    imagem_selecionada_comentario: function () {
      if (this.imagem_selecionada_comentario) {
        this.excluirImagemComentario(this.imagem_selecionada_comentario)
        this.questao.imagensComentario.push(this.imagem_selecionada_comentario)
      }
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()

      if (this.questaoEdicao) {
        this.questaoEdicao.imagensEnunciado = []
        this.questaoEdicao.imagensComentario = []
        this.questaoEdicao.removerImagensEnunciado = []
        this.questaoEdicao.removerImagensComentario = []
        if (!this.questaoEdicao.modalidade_id) {
          this.questaoEdicao.modalidade_id = ''
        }
        this.questao = Object.assign({}, this.questaoEdicao)
      } else {
        this.questao = {
          tipo_questao_id: 1,
          questao: '',
          enunciado: '',
          resposta1: '',
          resposta2: '',
          resposta3: '',
          resposta4: '',
          resposta5: '',
          opcao_correta: '',
          gabarito_discursiva: '',
          comentario_feedback: '',
          ano: '',
          professor_id: '',
          modalidade_id: '',
          publico_id: '',
          fonte_id: '',
          imagensEnunciado: [],
          imagensComentario: []
        }
      }
    })
  },

  validations: {
    questao: {
      tipo_questao_id: { required },
      questao: { required },
      enunciado: { required },
      resposta1: {
        required: requiredIf(function () {
          return this.isMultiplaEscolha
        })
      },
      resposta2: { required },
      resposta3: { required },
      resposta4: { required },
      opcao_correta: { required },
      ano: { required }
    }
  },

  methods: {
    obterUrlS3: function (arquivo) {
      return UrlUtils.obterUrlS3(arquivo)
    },

    show: function () {
      this.$bvModal.show('modal-cadastrar')
    },

    cadastrarQuestao: function () {
      this.$v.questao.$touch()
      if (!this.$v.questao.$invalid) {
        const loader = this.$loading.show()

        QuestaoAPI.salvar(this.questao).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            title: 'Questão criada com sucesso!',
            text: 'Deseja criar outra semelhante?'
          }).then((result) => {
            if (result.value) {
              this.questao.enunciado = ' '
              this.questao.resposta1 = ' '
              this.questao.resposta2 = ' '
              this.questao.resposta3 = ' '
              this.questao.resposta4 = ' '
              this.questao.resposta5 = ' '
              this.questao.opcao_correta = ' '
              this.questao.comentario_feedback = ' '
              this.questao.imagensEnunciado = []
              this.questao.imagensComentario = []
              this.questao.questao = this.questao.questao + '- Cópia'
            } else {
              this.$bvModal.hide('modal-cadastrar')
              this.$emit('questaoSalva', this.questao)
            }
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },

    editarQuestao: function () {
      this.$v.questao.$touch()
      if (!this.$v.questao.$invalid) {
        const loader = this.$loading.show()

        QuestaoAPI.editar(this.questao).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Questão atualizada com sucesso!'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar')
            this.$emit('questaoSalva', this.questao)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },

    excluirImagemEnunciado: function (imagem) {
      this.questao.imagensEnunciado = this.questao.imagensEnunciado.filter(item => (
        item.name !== imagem.name
      ))
    },

    excluirImagemEnunciadoGravadas: function (imagem) {
      this.questao.imagens_enunciado = this.questao.imagens_enunciado.filter(item => (
        item.arquivo !== imagem.arquivo
      ))
      this.questao.removerImagensEnunciado.push(imagem.id)
    },

    excluirImagemComentario: function (imagem) {
      this.questao.imagensComentario = this.questao.imagensComentario.filter(item => (
        item.name !== imagem.name
      ))
    },

    excluirImagemComentarioGravadas: function (imagem) {
      this.questao.imagens_comentario = this.questao.imagens_comentario.filter(item => (
        item.arquivo !== imagem.arquivo
      ))
      this.questao.removerImagensComentario.push(imagem.id)
    }
  }
}
</script>

<style>
  select#disciplina {
    text-transform: capitalize;
  }
</style>
